/**
 * Lowercases the input and uppercases the first character of every word, where a word starts
 * at the beginning of the input, after a space or after a hyphen — so both halves of a
 * double-barrelled name keep their capital.
 *
 * @example
 * capitalize("abC-DefG") // "Abc-Defg"
 * capitalize("hans-peter müller") // "Hans-Peter Müller"
 * @param input - The string to capitalize.
 * @returns The input in lowercase, with the first character of every word uppercased.
 */
export function capitalize(input: string): string {
	// The capturing group keeps each separator as its own segment, so joining on "" restores it.
	const segments = input.toLowerCase().split(/([ -])/);
	const capitalizedSegments = segments.map((segment) => {
		if (segment.length === 0) return segment;
		return segment.charAt(0).toUpperCase() + segment.slice(1);
	});
	return capitalizedSegments.join("");
}
